// ============================================================================= //
//  Dependencies
// ============================================================================= //
import Lenis from '@studio-freight/lenis';

// ============================================================================= //
//  Smooth scroll
// ============================================================================= //
const lenis = new Lenis( {
	duration: 2
});

window.lenis = lenis;

function raf( time ) {
	lenis.raf( time );
	requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

// ============================================================================= //
//  Smooth scroll to anchor links
// ============================================================================= //
const anchor = document.querySelectorAll('a[href^="#"]');

if ( anchor.length ) {
	anchor.forEach( (link) => {

		link.addEventListener('click', function (e) {
			e.preventDefault();
			const target = document.querySelector( this.getAttribute('href') );
			if ( ! target ) return;
			lenis.scrollTo( target.getBoundingClientRect().top + window.scrollY );
		});
	});
}
